import Component from '../../classes/Component';
import intlTelInput from '../../plugins/intl-tel-input/intlTelInput';
import {$dom} from "../../helpers/dom";
import {getMeta, isElement} from "../../helpers/_utilities";
import {$events} from "../../helpers/events";
import InputMask from 'inputmask';
import variables from "../../variables";
import {$style} from "../../helpers/style";
import '../../plugins/intl-tel-input/utils';
import {localizedCountries, countriesPhonePlaceholders} from "../../helpers/_countries";

const {classNames, metaNames} = variables;
const rootSelector = '.'+classNames.intlTelInput;
const parentSelector = '.js-intl-parent';
const onlyCountriesAttr = 'data-only-countries';

export default function () {

    return new Component({
        name: 'intlTelInput',
        requiredTargets: rootSelector,
        onCreate() {
            this.initCountry = getMeta(metaNames.locale);

            if (this.initCountry === 'ab') {
                this.initCountry = 'ru';
                delete localizedCountries.ab
            }

            if (this.initCountry === 'en')
                this.initCountry = 'az';

            const toggleBlur = action => {
                if ($dom.hasClass(document.body, classNames.intlTelInputMobile) && Boolean($dom[action]))
                    $dom[action](document.body, 'iti-blurred')
            };

            this.handlePlaceholderChange = function() {
                if (this.intlTel) {
                    let tempVal;

                    if (this.value.trim()) {
                        tempVal = this.value;
                        this.value = '';
                    }

                    const placeholder = $dom.attr(this, 'placeholder');

                    if (!placeholder) return;

                    if (this.mask && this.mask.remove) this.mask.remove();

                    this.mask = InputMask({
                        mask: placeholder,
                        showMaskOnHover: false,
                        keepStatic: true
                    }).mask(this);

                    if (tempVal) this.value = tempVal;
                }
            };

            this.provideValueToHiddenInput = arg => {
                let input = arg;

                if (arg instanceof Event)
                    input = arg.target;

                const parent = input.closest(parentSelector);

                if (isElement(parent)) {
                    const hiddenInput = $dom.get('input[name="phone"][type="hidden"]', parent);
                    if (input.intlTel && input.intlTel.getNumber())
                        hiddenInput.value = input.intlTel.getNumber();
                }
            };

            this.createIntlTelInput = target => {
                let onlyCountriesValues = target.getAttribute(onlyCountriesAttr);
                const countries = localizedCountries;

                if (onlyCountriesValues) {
                    onlyCountriesValues
                        .split(',')
                        .forEach(onlyCountryName => {
                            for (const countryName in countries) {
                                if (onlyCountryName !== countryName) {
                                    delete countries[countryName]
                                }
                            }
                        })
                    ;
                }

                target.intlTel = intlTelInput(target, {
                    initialCountry: this.initCountry,
                    formatOnDisplay: true,
                    separateDialCode: true,
                    onlyCountries: Object.keys(countries),
                    localizedCountries: countries,
                    hiddenInput: 'phone',
                    customPlaceholder: function(selectedPlaceholder, selectedData) {
                        const existingPl = countriesPhonePlaceholders[selectedData?.iso2];

                        if (existingPl)
                            return existingPl.replaceAll('*', '9')

                        return selectedPlaceholder
                    },
                });

                target.intlTel.promise.then(() => {
                    this.handlePlaceholderChange.call(target);
                    this.provideValueToHiddenInput(target)
                });

                return target.intlTel
            };

            this.handleOpen = () => toggleBlur('addClass');
            this.handleClose = () => toggleBlur('removeClass');

            this.handlePhonePaste = (e) => {
                const paste = (e.clipboardData || window.clipboardData).getData('text');

                paste && e.target?.intlTel.setNumber(paste);
            }
        },
        onInit() {

            $dom.each(this.targets, this.createIntlTelInput);

            $events.delegate
                .on('countrychange', rootSelector, this.handlePlaceholderChange)
                .on('open:countrydropdown', rootSelector, this.handleOpen)
                .on('close:countrydropdown', rootSelector, this.handleClose)
                .on('input', rootSelector, this.provideValueToHiddenInput)
                .on('paste', rootSelector, this.handlePhonePaste)
        },
        onDestroy() {
            $dom.each(this.targets, target => {
                if (target.intlTel) {
                    $style.remove(target, 'padding-left');
                    target.intlTel.destroy();
                }
                if (target.mask) target.mask.remove()
            });

            $events.delegate
                .off('countrychange', rootSelector, this.handlePlaceholderChange)
                .off('open:countrydropdown', rootSelector, this.handleOpen)
                .off('close:countrydropdown', rootSelector, this.handleClose)
                .off('input', rootSelector, this.provideValueToHiddenInput)
        }
    })
}
